/* @flow */

import { callLiferayEndpoint } from './index';
import utils from './utils';

import type { Area } from 'types';

const find = async (): Promise<Area[]> => {
  const response = await callLiferayEndpoint('/protones-portlet.usermanagement/get-user-areas', {});
  return response.map(utils.toArea);
};

export default {
  find,
};
